import { entityColumnsConfig, entityDrawerOrder } from '@/config/entityColumns';
import type { EntityType } from '@/types/api';

interface EntityDrawerProps {
  selectedEntity: EntityType;
  onSelect: (entity: EntityType) => void;
}

export function EntityDrawer({ selectedEntity, onSelect }: EntityDrawerProps) {
  return (
    <nav className="w-56 flex-shrink-0 border-r border-gray-200 bg-gray-50 overflow-y-auto">
      <ul className="py-2">
        {entityDrawerOrder.map((entityType) => {
          const config = entityColumnsConfig[entityType];
          const isSelected = entityType === selectedEntity;
          return (
            <li key={entityType}>
              <button
                type="button"
                onClick={() => onSelect(entityType)}
                className={`w-full text-left px-4 py-2.5 text-sm transition-colors ${
                  isSelected
                    ? 'bg-primary-50 text-primary-700 font-medium border-r-2 border-primary-600'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                {config.label}
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
